import axios from "axios";
//自定义axios
export default {
  install: async function(Vue, configPath) {
    Vue.prototype.userApi = {
      //获取验证码图片
      async getCodeImageBase64() {
        let time = new Date();
        var res = await Vue.prototype.EduUserAxios({
          method: "get",
          url: "/captchabase64" + "?" + time.getTime(),
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //用户登录
      async userLogin(name, pass, code) {
        let time = new Date();
        var res = await Vue.prototype.EduUserAxios({
          method: "post",
          url: "/login",
          data: {
            loginName: name,
            loginPwd: pass,
            captchaCode: code,
            timeOutMinute: 1440, //1天
          },
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },

      //用户登出
      async logout() {
        //console.log('dfsfd')
        var res = await Vue.prototype.EduUserAxios({
          method: "get",
          url: "/logout",
        });
        //console.log("logout:")
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //修改密码
      async updatePassword(oldpassword, newpassword) {
        var data = {
          OldPassWord: oldpassword,
          NewPassWord: newpassword,
        };
        console.log(data);
        var res = await Vue.prototype.EduUserAxios({
          method: "put",
          url: "/user/pwd",
          data: data,
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //单位成员查询
      async getEmps(searchName, pageIndex = 1, pageSize = 10) {
        var data = {
          Platform: true,
          Name: searchName,
          PageNumber: pageIndex,
          PageSize: pageSize,
        };
        var res = await Vue.prototype.EduUserAxios({
          method: "get",
          url: "/emps",
          params: data,
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //获取单位列表
      async getUnitAll() {
        var res = await Vue.prototype.EduUserAxios({
          method: "get",
          url: "/unit",
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      async getUnits() {
        var res = await Vue.prototype.EduUserAxios({
          method: "get",
          url: "/unit/list",
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      getUnitName(units, unId) {
        var name = "";
        for (var i = 0; i < units.length; i++) {
          if (units[i].id == unId) {
            name = units[i].name;
            break;
          }
        }
        return name;
      },
    }; //user api end
  }, //install end
};
